import {
  customerGroupSchema,
  CustomerGroupSurface,
  CustomerGroupType,
  segmentSortFieldSchema,
} from "@redotech/redo-customer-segments-common/customers/customer-group-definition";
import { SortDirectionSchema } from "@redotech/redo-views-common/table";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod";

export const fetchTeamSegments = {
  name: "fetchTeamSegments" as const,
  description:
    "List the team's existing audiences/segments. Check here before createDynamicSegment to reuse an audience, and to find an audience to target with createCampaign.",
  mutates: false,
  input: z.object({
    segmentType: createEnum(CustomerGroupType).optional(),
    searchText: z.string().optional(),
    page: z.number().int().min(1).optional(),
    pageSize: z.number().int().min(1).max(100).optional(),
    sort: z
      .object({ field: segmentSortFieldSchema, direction: SortDirectionSchema })
      .optional(),
    /** Omitted returns marketing's own segments; other surfaces are opt-in. */
    surface: createEnum(CustomerGroupSurface).optional(),
  }),
  output: z.object({
    segments: z.array(customerGroupSchema),
    totalCount: z.number().int().min(0),
  }),
};
